import { create } from 'zustand';
import type { IconName } from '@/design-system/icons/Icon';

export type Toast = { id: number; message: string; icon: IconName };

type ToastState = {
  toasts: Toast[];
  push: (message: string, icon?: IconName) => void;
  dismiss: (id: number) => void;
};

let counter = 0;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (message, icon = 'check') => {
    const id = ++counter;
    set((s) => ({ toasts: [...s.toasts, { id, message, icon }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 2600);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = (message: string, icon?: IconName) => useToastStore.getState().push(message, icon);
